/**
 * 텔레그램 연동보상 (#0010976) FE·BE 공유 상수.
 *
 * 보상 메시지의 제목·내용 길이 제한과 이모지(utf8mb3) 검증은 **여기서 재정의하지 않는다.**
 * 같은 `advdedicated.messages` 테이블에 적재되므로 제약이 동일하다 —
 * `adv-lib/src/v2/constants/telegram-event` 의
 * `TELEGRAM_EVENT_REWARD_TITLE_MAX` / `TELEGRAM_EVENT_REWARD_CONTENT_MAX` /
 * `hasNonBmpChar` / `validateTelegramEventRewardMessage` 를 **직접 import** 해서 쓴다(재export 금지).
 */

/**
 * 연동 요청 결과 케이스 (기획 p.14 가/나/다/라).
 * `ISetUserGameOptions.Schema.linkCase` 로 내려가며, 인게임이 팝업/토스트를 분기하는 기준이다.
 */
export enum TELEGRAM_LINK_CASE {
  /** 가: 처음 연동 — 연동완료 팝업 노출 */
  NEW = 1,
  /** 나: 현재와 다른 고유번호로 변경 연동 — 연동완료 팝업 노출 */
  CHANGED = 2,
  /** 다: 현재 연동된 고유번호를 그대로 재입력 — 연동 유지, 보상 판정 미진입 */
  ALREADY = 3,
  /** 라: 존재하지 않는 고유번호 — 연동되지 않음 */
  NOT_FOUND = 4,
}

/** 지급 기록(telegram_link_reward_grant.grantState) 상태 */
export enum TELEGRAM_LINK_REWARD_GRANT_STATE {
  /** 메시지함 발송 완료 */
  SENT = 0,
  /** 발송 실패 — 연동은 성공 유지, errorMessage 로 재처리 대상 식별 */
  SEND_FAIL = 1,
  /**
   * 기록만 되고 발송 결과를 확정하지 못한 상태 (INSERT 직후 기본값).
   *
   * **"발송 여부 불명"이지 "미발송"이 아니다.** 발송 직후 상태 갱신이 실패했거나
   * 그 사이 프로세스가 내려간 경우가 여기 남는다. 재처리 시 메시지함을 먼저 확인해야 하며,
   * 확인 없이 재발송하면 중복 지급이 된다.
   */
  PENDING = 2,
}

/** 설정 변경 이력(telegram_link_reward_config_history.action) 액션 */
export enum TELEGRAM_LINK_REWARD_HISTORY_ACTION {
  CREATE = 0,
  UPDATE = 1,
}

/**
 * 미지급 사유. 로그·테스트 판별용이며 **유저에게 노출하지 않는다.**
 * (연동 자체는 성공하므로 인게임 UI 는 이 값을 쓰지 않는다)
 */
export enum TELEGRAM_LINK_REWARD_DENY {
  /** CI 없는 계정 — 지급하지 않고 로그만 남긴다 */
  NO_CI = 'no_ci',
  /** 어드민 보상 값 미입력/0 — 지급도 메시지 발송도 하지 않는다 */
  NO_REWARD = 'no_reward',
  /** 이미 지급받은 명의 — grant.ci UNIQUE 충돌로 판정 */
  ALREADY_GRANTED = 'already_granted',
}

/**
 * 연동완료 팝업 이미지 업로드 허용 MIME → 확장자 매핑.
 *
 * 확장자를 업로드 파일명에서 뽑으면 사용자 입력이 그대로 S3 키에 들어간다.
 * MIME 화이트리스트로 고정하고, 목록에 없는 형식은 서버에서 거부한다.
 * 프론트 `accept` 속성도 이 목록과 동일하게 맞춘다.
 */
export const POPUP_IMAGE_MIME_EXT: { [mime: string]: string } = {
  'image/png': 'png',
  'image/jpeg': 'jpg',
  'image/gif': 'gif',
  'image/webp': 'webp',
}
